import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PageHeader } from '../components/PageHeader';
import { Reveal } from '../components/Reveal';
import { CTASection } from '../components/CTASection';
import { investments, investmentRoles } from '../data/investments';
export function Investments() {
  const [role, setRole] = useState<string>('All');
  const visible = role === 'All' ? investments : investments.filter(i => i.role === role);
  return <>
      <PageHeader eyebrow="Investments & portfolio" title="Companies I build, back and steward." intro="Early-stage conviction across fintech, climate, health, logistics and applied AI — as founder, investor, advisor and board member." data-id="element-402" data-mp="128nh0d0hzvaz" />

      <section className="px-6 sm:px-10" data-id="element-403" data-mp="sdddtlyd5hvm">
        <div className="mx-auto max-w-[92rem]" data-id="element-404" data-mp="3i0l2drkwrmxd">
          <div className="flex flex-wrap gap-2 border-y border-charcoal/[0.08] py-5" data-id="element-405" data-mp="3hy8d0tctmaaa">
            {investmentRoles.map(r => <button key={r} type="button" onClick={() => setRole(r)} className={`rounded-full px-4 py-2 text-[0.75rem] uppercase tracking-[0.12em] transition-all duration-500 ${role === r ? 'bg-charcoal text-ivory' : 'text-charcoal/55 hover:bg-charcoal/[0.05] hover:text-charcoal'}`} data-id="element-406" data-mp="9owpxnrsahz6">
                {r}
              </button>)}
          </div>

          <motion.ul layout className="grid gap-px overflow-hidden rounded-[1.5rem] border border-charcoal/[0.09] bg-charcoal/[0.09] sm:grid-cols-2 lg:grid-cols-3" style={{
          marginTop: '3.5rem'
        }} data-id="element-407" data-mp="3qx0fvhp6ruwf">
            <AnimatePresence mode="popLayout" data-id="element-408" data-mp="3i4ouia8xixnb">
              {visible.map(c => <motion.li key={c.name} layout initial={{
              opacity: 0
            }} animate={{
              opacity: 1
            }} exit={{
              opacity: 0
            }} transition={{
              duration: 0.45,
              ease: [0.22, 1, 0.36, 1]
            }} className="group relative flex min-h-[15rem] flex-col justify-between bg-ivory p-8 transition-colors duration-700 hover:bg-ivorydeep" data-id="element-409" data-mp="337pmwme2v4su">
                  <div data-id="element-410" data-mp="2ad9ntmrfv2tj">
                    <p className="font-serif text-[1.75rem] font-light leading-tight text-charcoal" data-id="element-411" data-mp="2adsyciereoxj">
                      {c.name}
                    </p>
                    <p className="mt-2 text-xs uppercase tracking-[0.16em] text-charcoal/40" data-id="element-412" data-mp="331f7e66ralrs">
                      {c.sector} · {c.location}
                    </p>
                  </div>
                  <div data-id="element-413" data-mp="2y45cib0llhwk">
                    <p className="max-h-0 overflow-hidden text-sm leading-relaxed text-charcoal/60 opacity-0 transition-all duration-700 ease-editorial group-hover:max-h-24 group-hover:opacity-100" data-id="element-414" data-mp="2t3r0yizsfpts">
                      {c.note}
                    </p>
                    <div className="mt-6 flex items-center justify-between border-t border-charcoal/[0.1] pt-4" data-id="element-415" data-mp="1hmrbdv4trp3g">
                      <span className="text-xs uppercase tracking-[0.14em] text-mocha" data-id="element-416" data-mp="3t9l1bbkuxylv">
                        {c.role}
                      </span>
                      <span className="text-xs text-charcoal/40" data-id="element-417" data-mp="736c20usdtkn">{c.stage}</span>
                    </div>
                  </div>
                </motion.li>)}
            </AnimatePresence>
          </motion.ul>

          <Reveal data-id="element-418" data-mp="gthefiytnupf">
            <p className="py-16 text-sm text-charcoal/45" data-id="element-419" data-mp="gw3q9usqwwdg">
              Showing {visible.length} of {investments.length} companies. Selected
              positions only; some holdings are undisclosed.
            </p>
          </Reveal>
        </div>
      </section>

      <CTASection data-id="element-420" data-mp="ush6z1pggtqv" />
    </>;
}